var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintenanceFallbackLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    fill: "none",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 18
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m295 70 110 145-110 145M135 70 25 215l110 145"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 215,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 215,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 215,
    r: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceFallbackLight);
export default __webpack_public_path__ + "static/media/maintenance_fallback_light.185ffcd6948ee1ac1d0ccc15c1798edd.svg";
export { ForwardRef as ReactComponent };